export default "__VITE_ASSET__DX1vC22B__"